module.exports = "<% var map = getPermissionNameMap() %>\n<% var permissions = []; %>\n<% _.each(map.modelPermissions, function(entry){ if(entry.func(mod.get('id'))) permissions.push(entry.name) }) %>\n<div class=\"col-md-7 col-sm-7 col-xs-12\"><%- permissions.join(', ') %></div>\n";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/account/team/permissionDetailsOverview.html
// module id = 580
// module chunks = 7